// extracted by mini-css-extract-plugin
export default {"root":"change-password_root__IwU4G","form":"change-password_form__hdem0","header":"change-password_header__3YzOk","button":"change-password_button__aVyN1"};